import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./madurai.css";
import axios from "axios";
const APIURL = process.env.REACT_APP_BASE_URL;


export default function KundaliMatchResult() {
    const [matchResult, setMatchResult] = useState([]);
    const [bplanets, setBPlanets] = useState([]);
    const [gplanets, setGPlanets] = useState([]);
    const location = useLocation();
    const state = location.state;
    const data = [
        { sign: "Aries", msg: "Positive" },

    ];

    const charts = async () => {
        try {
            const [boyyear, boymonth, boyday] = state.boydob.split("-").map(Number);
            const [boyhour, boyminute] = state.boytob.split(":").map(Number);
            const [girlyear, girlmonth, girlday] = state.girldob.split("-").map(Number);
            const [girlhour, girlminute] = state.girltob.split(":").map(Number);
            const postData = {
                boyname: state.name,
                boyyear,
                boymonth,
                boyday,
                boyhour,
                boyminute,
                girlname: state.name,
                girlyear,
                girlmonth,
                girlday,
                girlhour,
                girlminute,
            }
            console.log("==>",postData)
            const response = await axios.post(`${APIURL}/KundaiMatch`, postData);
            console.log("data==>", response.data);
            setBPlanets(response.data.boychart.planets);
            setGPlanets(response.data.girlchart.planets);
            setMatchResult(response.data.matchResult);
            //return response.data;
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        // Fetch the data
        charts();

        //setPosts(data);
    }, []);

    const getBRasi = (index) => {
        let rasi = bplanets.filter(f => f.rasi.no === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.map(m => m.planet.enShort).join(" ");
        } else {
            return "";
        }
    }

    const getGRasi = (index) => {
        let rasi = gplanets.filter(f => f.rasi.no === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.map(m => m.planet.enShort).join(" ");
        } else {
            return "";
        }
    }

    const isBRasiASC = (index) => {
        let rasi = bplanets.filter(f => f.rasi.no === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.some(m => m.planet.enShort === 'Asc');;
        } else {
            return false;
        }
    }

    const isGRasiASC = (index) => {
        let rasi = gplanets.filter(f => f.rasi.no === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.some(m => m.planet.enShort === 'Asc');;
        } else {
            return false;
        }
    }


    const getBNavamsa = (index) => {
        let rasi = bplanets.filter(f => f.navansa === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.map(m => m.planet.enShort).join(" ");
        } else {
            return "";
        }
    }

    const getGNavamsa = (index) => {
        let rasi = gplanets.filter(f => f.navansa === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.map(m => m.planet.enShort).join(" ");
        } else {
            return "";
        }
    }

    const isBNavamsaASC = (index) => {
        let rasi = bplanets.filter(f => f.navansa === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.some(m => m.planet.enShort === "Asc");
        } else {
            return false;
        }
    }


    const isGNavamsaASC = (index) => {
        let rasi = gplanets.filter(f => f.navansa === index);
        console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            console.log("====>", rasi[0])
            return rasi.some(m => m.planet.enShort === "Asc");
        } else {
            return false;
        }
    }

    return (
        <div >
            <h2 className="section-title">Daily Horoscope</h2>

            <p className="description">
                This astrology system follows the traditional south Indian Thirukanitham method, using Lahiri Ayanamsa
                for precise sidereal planetary calculations. All planetary positions, charts, and predictions are computed based
                on the Gregorian calendar and aligned with classical Vedic astrology principles. The approach emphasizes accuracy,
                authenticity, and adherence to time-tested astronomical calculations.<br />
            </p>

            <div>
                <table className="tablecard" >
                    <thead>
                        <tr>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Planets</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Degrees</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Rasi</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Rasi Lord</h3>
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {matchResult.map((result) => (
                            <tr key={result.name}>
                                <td className="tablecardCell">
                                    <div className="box">{result.name}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{result.status}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{result.description}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{result.description}
                                    </div></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="chartboxmain">
                {bplanets &&
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(12) ? "chartboxASC" : "chartbox"}>{getBRasi(12)}</div>
                                    </td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(1) ? "chartboxASC" : "chartbox"}>{getBRasi(1)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(2) ? "chartboxASC" : "chartbox"}>{getBRasi(2)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(3) ? "chartboxASC" : "chartbox"}>{getBRasi(3)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(11) ? "chartboxASC" : "chartbox"}>{getBRasi(11)}</div></td>
                                    <td className="tablecardCell" rowSpan="2" colSpan="2">
                                        <div className="chartboxcenter">Rasi</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(4) ? "chartboxASC" : "chartbox"}>{getBRasi(4)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(10) ? "chartboxASC" : "chartbox"}>{getBRasi(10)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(5) ? "chartboxASC" : "chartbox"}>{getBRasi(5)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(9) ? "chartboxASC" : "chartbox"}>{getBRasi(9)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(8) ? "chartboxASC" : "chartbox"}>{getBRasi(8)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(7) ? "chartboxASC" : "chartbox"}>{getBRasi(7)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBRasiASC(6) ? "chartboxASC" : "chartbox"}>{getBRasi(6)}</div></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                }


                {bplanets &&
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(12) ? "chartboxASC" : "chartbox"}>{getBNavamsa(12)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(1) ? "chartboxASC" : "chartbox"}>{getBNavamsa(1)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(2) ? "chartboxASC" : "chartbox"}>{getBNavamsa(2)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(3) ? "chartboxASC" : "chartbox"}>{getBNavamsa(3)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell"><
                                        div className={isBNavamsaASC(11) ? "chartboxASC" : "chartbox"}>{getBNavamsa(11)}</div></td>
                                    <td className="tablecardCell" rowSpan="2" colSpan="2">
                                        <div className="chartboxcenter">Navamsa</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(4) ? "chartboxASC" : "chartbox"}>{getBNavamsa(4)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(10) ? "chartboxASC" : "chartbox"}>{getBNavamsa(10)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(5) ? "chartboxASC" : "chartbox"}>{getBNavamsa(5)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(9) ? "chartboxASC" : "chartbox"}>{getBNavamsa(9)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(8) ? "chartboxASC" : "chartbox"}>{getBNavamsa(8)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(7) ? "chartboxASC" : "chartbox"}>{getBNavamsa(7)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isBNavamsaASC(6) ? "chartboxASC" : "chartbox"}>{getBNavamsa(6)}</div></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                }

            </div>



            <div className="chartboxmain">
                {bplanets &&
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(12) ? "chartboxASC" : "chartbox"}>{getGRasi(12)}</div>
                                    </td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(1) ? "chartboxASC" : "chartbox"}>{getGRasi(1)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(2) ? "chartboxASC" : "chartbox"}>{getGRasi(2)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(3) ? "chartboxASC" : "chartbox"}>{getGRasi(3)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(11) ? "chartboxASC" : "chartbox"}>{getGRasi(11)}</div></td>
                                    <td className="tablecardCell" rowSpan="2" colSpan="2">
                                        <div className="chartboxcenter">Rasi</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(4) ? "chartboxASC" : "chartbox"}>{getGRasi(4)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(10) ? "chartboxASC" : "chartbox"}>{getGRasi(10)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(5) ? "chartboxASC" : "chartbox"}>{getGRasi(5)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(9) ? "chartboxASC" : "chartbox"}>{getGRasi(9)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(8) ? "chartboxASC" : "chartbox"}>{getGRasi(8)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(7) ? "chartboxASC" : "chartbox"}>{getGRasi(7)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGRasiASC(6) ? "chartboxASC" : "chartbox"}>{getGRasi(6)}</div></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                }


                {bplanets &&
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(12) ? "chartboxASC" : "chartbox"}>{getGNavamsa(12)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(1) ? "chartboxASC" : "chartbox"}>{getGNavamsa(1)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(2) ? "chartboxASC" : "chartbox"}>{getGNavamsa(2)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(3) ? "chartboxASC" : "chartbox"}>{getGNavamsa(3)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell"><
                                        div className={isGNavamsaASC(11) ? "chartboxASC" : "chartbox"}>{getGNavamsa(11)}</div></td>
                                    <td className="tablecardCell" rowSpan="2" colSpan="2">
                                        <div className="chartboxcenter">Navamsa</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(4) ? "chartboxASC" : "chartbox"}>{getGNavamsa(4)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(10) ? "chartboxASC" : "chartbox"}>{getGNavamsa(10)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(5) ? "chartboxASC" : "chartbox"}>{getGNavamsa(5)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(9) ? "chartboxASC" : "chartbox"}>{getGNavamsa(9)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(8) ? "chartboxASC" : "chartbox"}>{getGNavamsa(8)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(7) ? "chartboxASC" : "chartbox"}>{getGNavamsa(7)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isGNavamsaASC(6) ? "chartboxASC" : "chartbox"}>{getGNavamsa(6)}</div></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                }

            </div>
        </div>


    );
}